import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';
import AboutImg from '../assets/images/about-img.jpg';

function AboutUsSection() {
  return (
    <Box sx={{ marginBottom: '3rem' }}>
        <Container>
            <Box sx={{ 
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' }
            }}>
                <Box sx={{ 
                    width: { xs: '100%', md: '50%' },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    paddingRight: { xs: 0, md: '1rem' }
                }}>
                    <Typography 
                        variant='h2'
                        sx={{
                            fontSize: 'clamp(1.8rem, 1.3654rem + 0.9065vw, 2rem)',
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            marginBottom: '1rem'
                        }}
                    >
                        About us
                    </Typography>
                    <Typography>
                    PR-Builders, established in 2010, is a trusted construction company based near East Tambaram, Chennai,
                    Tamil Nadu—serving Tambaram, South Chennai, and the wider metro with residential and commercial building work. With a strong commitment to
                    quality and innovation, we have successfully completed over 100
                    projects. Our focus on excellence, timely delivery, and customer
                    satisfaction has earned us a solid reputation with homeowners and businesses across the region.
                    </Typography>
                    <Box sx={{
                        marginTop: '1rem'
                    }}>
                        <Link to='/about' >
                            <Button 
                               variant="contained" 
                               size="large"
                               sx={{
                                 textTransform: 'capitalize',
                                 backgroundColor: '#00bf63',
                                 '&:hover': {
                                   backgroundColor: '#00c05a',
                                 },
                               }}
                            >
                                More about us
                            </Button>
                        </Link>
                    </Box>
                </Box>
                <Box 
                    sx={{ 
                        width: { xs: '100%', md: '50%' },
                        display: 'flex',
                        justifyContent: 'center',
                        paddingLeft: { md: 0, lg: '6rem' },
                        paddingTop: { xs: '2rem', md: 0 }
                    }}>
                    <img 
                        src={AboutImg} 
                        alt="PR Builders construction company East Tambaram Chennai" 
                        style={{ 
                            height: 'auto', 
                            maxWidth: '100%',
                            borderRadius: '5px' 
                        }} 
                    />
                </Box>
            </Box>
        </Container>
    </Box>
  )
}

export default AboutUsSection;